<template>
    <div>
        <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
            <navcon></navcon>
        </div>
        <div class="index-page"></div>

        <!-- banner -->
        <div class="banner">
            <el-carousel trigger="click" :height="height + 'px'">
                <el-carousel-item v-for="item,index in banner" :key="index">
                    <img class="banner" ref="height1" @load="imgLoad" :src="item.bannerImg" @click="onTransParam(item.transParam)">
                </el-carousel-item>
            </el-carousel>
        </div>

        <div class="main-con html">
            <div class="search-form">
                <p class="popup-title">证书查询</p>
                <div class="popup-form">
                <el-form label-position="top" label-width="100px" :model="userInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                    <el-form-item label="证书类别:" prop="typeId">
                        <el-select v-model="userInfo.typeId" filterable placeholder="请选择证书类别" style="width: 100%">
                            <el-option
                            style="font-size: 12px;"
                            v-for="item in certList"
                            :key="item.id"
                            :label="item.certName"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="姓名：" prop="name">
                        <el-input v-model="userInfo.name" placeholder="请输入真实姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="证件号：" prop="idCard">
                        <el-input v-model="userInfo.idCard" placeholder="请输入证件号"></el-input>
                    </el-form-item>
                    <el-form-item label="证书编号：" prop="certNo">
                        <el-input v-model="userInfo.certNo" placeholder="请输入证书编号"></el-input>
                    </el-form-item>
                    <el-form-item style="text-align: center;margin-top: 50px;">
                        <el-button style="width: 180px; height: 40px; background-color: #ff821c" size="small" type="warning" :loading="loading" @click="submitForm('ruleForm')">查询</el-button>
                    </el-form-item>
                </el-form>
                </div>
            </div>
        </div>

        <el-dialog
            class="eldialog"
            title="证书信息"
            :visible.sync="dialogVisible"
            top="30vh"
            width="30%"
            >
            <p>证书名称：{{ queryCert.certName }}</p>
            <p>证书编号：{{ queryCert.certNum }}</p>
            <p>发证日期：{{ queryCert.certTime }}</p>
        </el-dialog>

        <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
            <footers></footers>
        </el-footer>
    </div>
</template>

<script>
import { bannerList, queryCert ,certList } from '../../api/userMG'
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'
export default {
    name: 'search',
    components: {
      navcon,
      footers,
    },
    data() {
        return {
            banner:[],
            height:'',
            userInfo:{
                typeId:'',
                name:'',
                idCard:'',
                certNo:''
            },
            rules: {
                typeId: [
                    { required: true, message: '请选择证书类别', trigger: 'change' }
                ],
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                idCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' }
                ],
                certNo:[
                    { required: true, message: '请输入证书编号', trigger: 'blur' }
                ]
            },
            loading:false,
            certList:[],
            dialogVisible:false,
            queryCert:{}
        }
    },
    mmounted() {
        this.imgLoad()
        window.addEventListener('resize',()=>{
            this.height =  this.$refs.height1[0].height
            this.imgLoad()
        })
    },
    created(){
        this.getBannerList();
        this.getCertList();
    },
    methods:{
        imgLoad(){
            var _that = this
            this.$nextTick(()=>{
                _that.height = _that.$refs.height1[0].height
                _that.$emit('style1',_that.height)//如果是子组件，就给父组件传递高度，设定父组件的高度
            })
        },
        // 获取banner
        getBannerList(){
            bannerList({location:1}).then(res => {
                console.log('banner',res.data);
                this.banner = res.data
            })
            .catch(err => {})
        },
        // 获取certList
        getCertList(){
            certList().then(res => {
                console.log('certList',res.data);
                this.certList = res.data
            })
            .catch(err => {})
        },
        submitForm(formName) {
            this.loading = true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    queryCert(this.userInfo).then(res => {
                        this.loading = false;
                        if(res.code == 0){
                            this.dialogVisible = true;
                            this.queryCert = res.data
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning',
                                offset:100
                            });
                        }
                       
                    })
                } else {
                    this.loading = false;
                    return false;
                }
            });
        },
    }
}
</script>

<style scoped>
    .banner{
        width: 100%;
        cursor: pointer;
    }
    .search-form{
        background: #FAFAFA;
        margin-top: 50px;
        margin-bottom: 100px;
        border-radius: 0px 0px 15px 15px 
    }
    .popup-title{
        background: #FF821E;
        height: 60px;
        line-height: 60px;
        text-align: center;
        color: #fff;
        border-radius: 15px 15px 0px 0px;

        font-family: SourceHanSansCN;
        font-weight: 400;
        font-size: 18px;
    }
    .demo-ruleForm{
        width: 60%;
        margin: auto;
        padding: 60px 0;
    }
    .eldialog /deep/ p{
        padding: 0 0 10px;  
    }

</style>


// WEBPACK FOOTER //
// src/views/index/search.vue